export default {
  chat: {
    transferToGeochat: 'Transfer to GeoChat',
    dialog: {
      salesChannel: {
        title: 'Sales Channel',
        message: 'The sales channel number has not been configured. Please configure it to continue.',
      },
    },
  },
};
